import { HeaderService } from '@qima-labs/app/pages/main/shared/components/header/shared/service/header.service';
import { ILanguage, LANGUAGES } from '@qsp-ui-library/constants/languages.constants';
import { IMyWindow } from '@qsp-ui-library/interfaces/my-window.interface';
import { EStorageKeys } from '@qsp-ui-library/models/enums/storage-keys.enum';
import { QimaColorService } from '@qsp-ui-library/services/exported-services/qima-color/qima-color.service';
import { QimaDotService } from '@qsp-ui-library/services/exported-services/qima-dot/qima-dot.service';
import { QimaShadowService } from '@qsp-ui-library/services/exported-services/qima-shadow/qima-shadow.service';
import { WINDOW } from '@qsp-ui-library/tokens/window.token';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import localForage from 'localforage';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'app-translate-menu',
  templateUrl: './translate-menu.component.html',
  styleUrls: ['./translate-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslateMenuComponent implements OnInit {
  public translateMenuItems: ILanguage[] = LANGUAGES;
  public activeIndex: number = this.translateMenuItems.findIndex((item): boolean => item.value === this._translateService.currentLang);

  public constructor(
    @Inject(WINDOW) private readonly _window: IMyWindow,
    private readonly _translateService: TranslateService,
    private readonly _headerService: HeaderService,
    public readonly shadowService: QimaShadowService,
    public readonly qimaDot: QimaDotService,
    public readonly qimaColor: QimaColorService
  ) {}

  public ngOnInit(): void {
    this.activeIndex = this._headerService.getActiveLanguageIndex();
    const language = this.translateMenuItems[this.activeIndex].value;

    this._translateService.use(language).pipe(untilDestroyed(this)).subscribe();
    this._watch();
  }

  public onTranslateMenuItemClick(index: number): void {
    this._onItemClick(index);
  }

  public onTranslateMenuItemEnter(index: number): void {
    this._onItemClick(index);
  }

  private _watch(): void {
    this._headerService.activeLanguageIndex$.pipe(untilDestroyed(this)).subscribe((index: number): void => {
      this.activeIndex = index;
    });
  }

  private _onItemClick(index: number): void {
    const language = this.translateMenuItems[index].value;

    void localForage.setItem(EStorageKeys.LOCALE_LANGUAGE, language);
    localStorage.setItem(EStorageKeys.LOCALE_LANGUAGE, language);
    this._updateActiveLanguageIndex(index);
    this._translateService.use(language).pipe(untilDestroyed(this)).subscribe();
    this._closeMenu();
    /* For the backend test */
    this._window.location.reload();
  }

  private _updateActiveLanguageIndex(_index: number): void {
    this._headerService.updateActiveLanguageIndex(_index);
  }

  private _closeMenu(): void {
    this._headerService.updateIsTranslateMenuVisible(false);
  }
}
